import React, { useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import Aos from "aos";
import "aos/dist/aos.css";
import Marca1 from "../../../assets/Images/BrandLogo/piuperformance-logo.png";
import Marca2 from "../../../assets/Images/BrandLogo/sceltopiu-logo.png";
export default function Marchi() {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);
  return (
    <>
      <div className="container" id="marchi">
        <div className="aboutus spacing">
          <Row className="align-items-center">
            <Col xl={6} lg={6} md={6} sm={6} xs={12} data-aos="zoom-in" className="details-summary">
              <Row>
                <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                  <div className="ba_beffect">
                    <img className="img-fluid mx-auto" alt="+Performance" src={Marca1} />
                  </div>
                </Col>
              </Row>
            </Col>
            <Col xl={6} lg={6} md={6} sm={6} xs={12} data-aos="fade-right" className="details-icon">
              <p className="paragraph">
                <b>+Performance</b> è una nuova linea di prodotti dalle elevate prestazioni pensati per i professionisti della ristorazione.
                <br />
                I Formati favoriscono un uso pratico e senza sprechi, con la novità di un'efficace comunicazione delle caratteristiche d'uso più rilevanti per ciascun genere di prodotto già in etichetta.
                <br /><br />
                <b>+Costanza nel tempo</b>
                <br />
                Ogni prodotto  +Performance è sviluppato in sinergia con fornitori per individuare le soluzioni più valide al fine di garantire proprietà standard costanti nel tempo che consentano al nostro cliente di preparare piatti con le medesime caratteristiche.
                <br /><br />
                <b>+Resa</b>
                <br />
                Ogni prodotto  +Performance evidenzia sul fronte della singola confezione le peculiarità specifiche del prodotto. Un aiuto in più per migliorare il business evitando sprechi o consumi scorretti del prodotto.
                <br /><br />
                <b>+Convenienza</b>
                <br />
                Ogni prodotto +Performance è studiato per poter offrire al mercato Ho.Re.Ca. prodotti con il giusto rapporto qualità/prezzo
              </p>
            </Col>
          </Row>
        </div>
        <div className="aboutus spacing">
          <Row className="align-items-center">
            <Col xl={6} lg={6} md={6} sm={6} xs={12} data-aos="fade-left" className="details-icon">
              <p className="paragraph">
                Il marchio <b>Scelto Più</b> identifica tutti i prodotti che vengono presentati e somministrati direttamente dal ristoratore o dal bar al consumatore finale.
                <br /><br />
                Scelto Più consente al nostro cliente di proporre un'offerta distintiva che, svincolandosi dal prodotto di marca, risponde puntualmente alle esigenze di qualità e appagamento del consumatore finale.
                <br />
                L'espressione qualitativa è valorizzata attraverso una selezione accurata dei prodotti, garantendo freschezza e genuinità. Grazie a Scelto Più, i nostri clienti possono offrire un esperienza unica e soddisfacente, distinguendosi nel mercato con prodotti di alta qualità.
                <br /><br />
                Scegliendo Scelto Più, ristoratori e bar possono fidelizzare la clientela, elevando il proprio servizio e proponendo un'offerta che si allinea perfettamente con le aspettative dei consumatori più esigenti
              </p>
            </Col>
            <Col xl={6} lg={6} md={6} sm={6} xs={12} data-aos="zoom-in" className="details-summary">
              <Row>
                <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                  <div className="ba_beffect">
                    <img className="img-fluid mx-auto" alt="Scelto Più" src={Marca2} />
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
}
